import qs from 'qs';

import i18n from '@/app/i18n';
import api from '@shared/api';

import {
    CreateEmployeeRequest,
    EmployeesRequest,
    EmployeesResponse,
    ResetPasswordRequest,
    TaxAuthorityDepartment,
    UpdateEmployeeRequest,
} from './type';

const PATH = '/uaa/company';
const USERS_PATH = '/uaa/users';
const REGISTRATION_PATH = `/uaa/registration`;
const RESET_PATH = `${REGISTRATION_PATH}/mfa/password/request`;

export const fetchEmployees = async (payload: EmployeesRequest) =>
    (
        await api.get<EmployeesResponse>(`${PATH}/${payload.lpId}/employees`, {
            params: payload,
            paramsSerializer: (p) => qs.stringify(p, {arrayFormat: 'repeat', skipNulls: true}),
        })
    ).data;

export const fetchInspectors = async (payload: EmployeesRequest) =>
    (
        await api.get<EmployeesResponse>(`${USERS_PATH}/inspectors`, {
            params: payload,
            paramsSerializer: (p) => qs.stringify(p, {arrayFormat: 'repeat', skipNulls: true}),
        })
    ).data;

// /users
export const fetchUsers = async (payload: EmployeesRequest) =>
    (
        await api.get<EmployeesResponse>(`${USERS_PATH}`, {
            params: payload,
            paramsSerializer: (p) => qs.stringify(p, {arrayFormat: 'repeat', skipNulls: true}),
        })
    ).data;

export const createEmployee = async (payload: CreateEmployeeRequest) =>
    (
        await api.post(`${REGISTRATION_PATH}/employee`, payload, {
            headers: {'Accept-Language': i18n.language},
        })
    ).data;

export const createInspector = async (payload: CreateEmployeeRequest) =>
    (
        await api.post(`${REGISTRATION_PATH}/inspector`, payload, {
            headers: {'Accept-Language': i18n.language},
        })
    ).data;

export const createChiefInspector = async (payload: CreateEmployeeRequest) =>
    (
        await api.post(`${REGISTRATION_PATH}/senior-inspector`, payload, {
            headers: {'Accept-Language': i18n.language},
        })
    ).data;

export const updateEmployee = async (payload: UpdateEmployeeRequest) =>
    (await api.put(`${USERS_PATH}/${payload.userId}`, payload.body)).data;

export const resetPassword = async (payload: ResetPasswordRequest) =>
    (
        await api.post(`${RESET_PATH}/reset`, payload, {
            headers: {'Accept-Language': i18n.language},
        })
    ).data;

export const resendInvitation = async (payload: ResetPasswordRequest) =>
    (
        await api.post(`${RESET_PATH}/create`, payload, {
            headers: {'Accept-Language': i18n.language},
        })
    ).data;

export const fetchTaxAuthorityDepartments = async () =>
    (await api.get<TaxAuthorityDepartment[]>(`/uaa/tax-department`)).data;
